import { CoreState, SessionState, NavState} from './_state.interfaces';
import { createSelector } from '@ngrx/store';

/**
 * セッションステートセレクタ
 */
export const selectSession = (state: CoreState) => state.session;
export const getLoading = createSelector(selectSession, (state: SessionState) => state.loading);
export const getSession = createSelector(selectSession, (state: SessionState) => state.auth);
export const getMessage = createSelector(selectSession, (state: SessionState) => state.message);
export const getUserInfo = createSelector(selectSession, (state: SessionState) => state.userInfo);
export const getAppId = createSelector(selectSession, (state: SessionState) => state.appId);
export const getAdminFlag = createSelector(selectSession, (state: SessionState) => state.admin);
export const getUserName = createSelector(selectSession, (state: SessionState) => state.userName);

/**
 * ナビバーステートセレクタ
 */
export const selectNav = (state: CoreState) => state.nav;
export const getShowMenu = createSelector(selectNav, (state: NavState) => state.showMenu);
export const getShowCart = createSelector(selectNav, (state: NavState) => state.showCart);
export const getOpenSideNav = createSelector(selectNav, (state: NavState) => state.openSideNav);
